/**
 * A registry of datasource from different elements
 * This allows actions from events to manipulate different datasources straight away.
 * The registry is kept in a map instead of an array, to easily identify, retrieve and delete datasources.
 */
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('DatasourceRegistry', DatasourceRegistryFactory);

    function DatasourceRegistryFactory(Path,lodash) {
        var datasources = {};
        return {
            add: add,
            remove: remove,
            clear: clear,
            refreshAll: refreshAll,
            get: get,
            refresh: refresh,
            getDs: getDs,
            prepare: prepare
        };

        function add(key,ds) {
            datasources[key] = ds;
        }

        function remove(key) {
            delete datasources[key];
        }

        function clear() {
            datasources = {};
        }

        function refreshAll(){
            for (var key in datasources) {
                datasources[key].read();
            }
        }

        function get(key) {
            return lodash.get(datasources,key,null);
        }

        function refresh(key) {
            datasources[key].read();
        }

        function getDs() {
            return datasources;
        }

        function prepare(ds) {
            var uri = Path.getApiPath(Path.replace(lodash.get(ds,'transport.read.url','')));

            lodash.set(ds,'transport.read.url',uri);
            return new kendo.data.DataSource(ds);
        }
    }
})();